import React, { Component } from "react";

import Link from "components/link/link";
import Button from "components/button/button";

import "./emptyCart.css";

export default class EmptyCart extends Component {
  render() {
    return (
      <div className="emptyCart">
        <Link to="/products">
          <div className="buttonContainer">
            <Button color="green">
              <p>Empty Cart</p>
              <p>Visit Store for Products</p>
            </Button>
          </div>
        </Link>
      </div>
    );
  }
}
